// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Modal
     */

    // Select elements in de DOM
    const openModalTriggers = document.querySelectorAll('.js-open-modal');
    const closeModalTriggers = document.querySelectorAll('.js-close-modal');
    const modals = document.querySelectorAll('.modal');

    // Open modal
    for (const openModalTrigger of openModalTriggers) {
        openModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = e.currentTarget.dataset.modal;
            openModal(modalId);
        });
    }

    const openModal = (modalId) => {
        for (const modal of modals) {
            if (modal.dataset.modal === modalId) {
                modal.classList.add('modal--visible');
                document.querySelector('body').classList.add('no-scroll');
            }
        }
    }

    // Close modal
    for (const closeModalTrigger of closeModalTriggers) {
        closeModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = e.currentTarget.dataset.modal;
            closeModal(modalId);
        });
    }

    const closeModal = (modalId) => {
        for (const modal of modals) {
            if (modal.dataset.modal === modalId) {
                modal.classList.remove('modal--visible');
                document.querySelector('body').classList.remove('no-scroll');
                document.dispatchEvent(new CustomEvent('modal:closed', { detail: { modalId } }));
            }
        }
    }

    // Close visible modal on Escape key press
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') {
            return;
        }

        for (const modal of modals) {
            if (modal.classList.contains('modal--visible')) {
                closeModal(modal.dataset.modal);
            }
        }
    });

});
